module.exports = __webpack_public_path__ + "img/default.ff4c45dd.png";